import { useQuery } from '@tanstack/react-query';
import { getUserClient } from '../lib/api-clients';
import { queryKeys } from '../lib/query-keys';

/**
 * Hook to fetch the current authenticated user.
 * Uses TanStack Query for caching and state management.
 */
export function useCurrentUser() {
  return useQuery({
    queryKey: queryKeys.users.me(),
    queryFn: () => getUserClient().getMe(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false, // Don't retry on 401 (handled by client redirect)
  });
}
